import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

const translations = {
    false: {
        recruiter: "Recruiter",
        candidate: "Candidate"
    },
    true: {
        recruiter: "Recruiter",
        candidate: "Kandidaat"
    }
};

const ViewModeToggle = ({ isRecruiterMode, setIsRecruiterMode, isDutch = false }) => {
    const [currentIsDutch, setCurrentIsDutch] = useState(isDutch);
    const t = translations[currentIsDutch];

    useEffect(() => {
        const checkLanguage = () => {
            const cookieIsDutch = Cookies.get('isDutch') === 'true';
            if (cookieIsDutch !== currentIsDutch) {
                setCurrentIsDutch(cookieIsDutch);
            }
        };

        checkLanguage();

        const interval = setInterval(checkLanguage, 1000);

        return () => clearInterval(interval);
    }, [currentIsDutch]);

    return (
        <div className="flex items-center gap-4">
            {/* <span className=" font-medium">View Mode</span> */}
            <div className="flex border rounded-md overflow-hidden">
                <button
                    className={`no-animation-button px-4 py-2 transition-colors duration-200 ${
                        isRecruiterMode
                            ? 'bg-buttonColor text-white'
                            : 'bg-white text-gray-700'
                    }`}
                    onClick={() => setIsRecruiterMode(true)}
                >
                    {t.recruiter}
                </button>
                <button
                    className={`no-animation-button px-4 py-2 transition-colors duration-200 ${
                        !isRecruiterMode
                            ? 'bg-buttonColor text-white'
                            : 'bg-white text-gray-700'
                    }`}
                    onClick={() => setIsRecruiterMode(false)}
                >
                    {t.candidate}
                </button>
            </div>
        </div>
    );
};

export default ViewModeToggle;